import { render, staticRenderFns } from "./AirKiss.vue?vue&type=template&id=51fbeaca&"
import script from "./AirKiss.vue?vue&type=script&lang=js&"
export * from "./AirKiss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports